import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button, FormGroup, Modal, ModalFooter, ModalHeader } from "reactstrap"
import ModalBody from "reactstrap/es/ModalBody"
import { Input, Select, Tooltip } from 'antd'

// Các carrier bắt buộc nhập cân nặng/kích thước thực tế trước khi đóng thùng
const HEAVY_CARRIERS = ['hw_usps', 'hw_tiktok', 'hw_ttship', 'teddy_4_life', 'zone9_us']

class CloseBox extends Component {
    constructor(props) {
        super(props)
        this.state = {
            closing: false,
            modal: false,
            modalBoxInfo: false,
            weight: props.box.real_weight ? props.box.real_weight : '',
            length: props.box.real_length ? props.box.real_length : '',
            width: props.box.real_width ? props.box.real_width : '',
            height: props.box.real_height ? props.box.real_height : '',
            errorValidate: {},
            typeSelected: '',
        }
    }

    _handleChangeType = (value) => {
        const { box } = this.props
        this.setState({
            typeSelected: value,
            length: value === 'bag' ? '10' : value === 'boxHw' ? '61' : box.real_length ? box.real_length : '',
            width: value === 'bag' ? '10' : value === 'boxHw' ? '42' : box.real_width ? box.real_width : '',
            height: value === 'bag' ? '10' : value === 'boxHw' ? '42' : box.real_height ? box.real_height : ''
        })
    }

    _setModal = () => {
        this.setState({
            modal: !this.state.modal
        })
    }

    _handleCancelModal = () => {
        this.setState({
            modal: false,
            modalBoxInfo: false
        })
    }

    _setModalBoxInfo = () => {
        const { box } = this.props
        this.setState({
            modalBoxInfo: !this.state.modalBoxInfo,
            weight: box.real_weight ? box.real_weight : '',
            length: box.real_length ? box.real_length : '',
            width: box.real_width ? box.real_width : '',
            height: box.real_height ? box.real_height : '',
            errorValidate: {}
        })
    }

    _handleCancelModalBoxInfo = () => {
        this.setState({
            modalBoxInfo: false
        })
    }

    _handleChangeInput = (e) => {
        const {errorValidate} = this.state
        const {name, value} = e.target
        const newErrorValidate = { ...errorValidate }
        if(newErrorValidate[name]){
            delete newErrorValidate[name]
        }
        
        this.setState({
            [name]: value,
            errorValidate: newErrorValidate
        })
    }

    _handleValidate = () => {
        const errorValidate = {}
        const { box } = this.props
        const {shipping_carrier} = box
        const {weight, length, width, height} = this.state

        if(HEAVY_CARRIERS.includes(shipping_carrier)){
            if (weight === '') {
                errorValidate.weight = 'Hãy nhập cân nặng!!!'
            }
            if (length === '') {
                errorValidate.length = 'Hãy nhập chiều dài!!!'
            }
            if (width === '') {
                errorValidate.width = 'Hãy nhập chiều rộng!!!'
            }
            if (height === '') {
                errorValidate.height = 'Hãy nhập chiều cao!!!'
            }
        }
        
        const checkWeight = !!errorValidate.weight && errorValidate.weight !== ''
        const checkLength = !!errorValidate.length && errorValidate.length !== ''
        const checkWidth = !!errorValidate.width && errorValidate.width !== ''
        const checkHeight = !!errorValidate.height && errorValidate.height !== ''

        this.setState({
            errorValidate
        })
        if (checkWeight || checkLength || checkWidth || checkHeight) {
            return true
        }
        return false
    }

    _handleConfirmClickClose = (e) => {
        e.preventDefault()

        const validate = this._handleValidate()
        if (validate) return

        const { box, barcodeError, confirmWarning } = this.props
        const barcodes = barcodeError.find(item => item.boxID === box._id)
        // Cần xác nhận khi có barcode quét sai HOẶC khi thùng còn đơn chưa đóng đủ.
        // Gộp vào cùng 1 modal vì hai điều kiện có thể xảy ra đồng thời — nếu tách
        // thành 2 modal thì người dùng phải xác nhận 2 lần hoặc modal che nhau.
        const needConfirm = barcodes !== undefined || !!confirmWarning

        this.setState({
            modal: needConfirm,
            modalBoxInfo: !needConfirm,
        }, () => {
            !needConfirm && this._handleClickClose()
        })
    }

    _handleClickClose = async () => {

        if (this.state.closing) return false

        // Chốt an toàn tầng hai: nút đã disable nhưng chặn thêm ở đây để bịt cả
        // đường đi qua modal nhập cân nặng của HEAVY_CARRIERS
        if (this.props.disabledReason) return false

        const r = window.confirm('Bạn có chắc chắc muốn đóng thùng này?')
        if (!r) return false

        this.setState({
            closing: true,
            modal: false,
            modalBoxInfo: false
        })

        try {
            const {weight, height, width, length} = this.state

            const payload = {
                "weight": +weight,
                "dimension": {
                    "width": +width,
                    "height": +height,
                    "length": +length
                }
            }
            
            await this.props.onClose(payload)

            this.setState({
                closing: false,
                weight: '',
                length: '',
                width: '',
                height: '',
            })
        } catch (e) {
            this.setState({
                closing: false,
                weight: '',
                length: '',
                width: '',
                height: '',
            })
        }
    }

    _renderCloseButton = () => {
        const { box, disabledReason } = this.props
        const { shipping_carrier } = box
        const { closing } = this.state
        const blocked = !!disabledReason

        const button = (
            <button
                disabled={closing || blocked}
                onClick={HEAVY_CARRIERS.includes(shipping_carrier) ? this._setModalBoxInfo : this._handleConfirmClickClose}
                className="btn btn-success mx-2"
            >
                Đóng thùng
            </button>
        )

        // Không bọc gì khi nút không bị chặn -> DOM của thùng thường giữ nguyên như cũ
        if (!blocked) return button

        // Tooltip của antd không bắt được mouse event trên <button disabled> nên phải
        // bọc thêm <span>, nếu không tooltip sẽ không bao giờ hiện và người dùng chỉ
        // thấy nút xám mà không biết lý do.
        return (
            <Tooltip title={disabledReason}>
                <span className="d-inline-block">{button}</span>
            </Tooltip>
        )
    }

    render() {
        const { box, barcodeError, position, confirmWarning } = this.props
        const barcodes = barcodeError.find(item => item.boxID === box._id)
        const { status, shipping_carrier } = box

        if (status !== 'opening') return null

        const { modal, modalBoxInfo, weight, length, width, height, errorValidate, typeSelected } = this.state

        return (
            <div className={position === 'footer' ? "CloseBox card-footer" : "CloseBox"}>
                {position === 'footer' &&
                    <div className="d-flex justify-content-center">
                        {this._renderCloseButton()}
                    </div>
                }
                {position !== 'footer' && this._renderCloseButton()}
                {modal && (
                    <Modal isOpen={modal} toggle={this._handleCancelModal}>
                        <ModalHeader toggle={this._handleCancelModal}>
                            {confirmWarning ? 'Xác nhận đóng thùng' : 'Danh sách barcode quét sai'}
                        </ModalHeader>
                        <ModalBody>
                            {!!confirmWarning && (
                                <div className="alert alert-warning mb-2">{confirmWarning}</div>
                            )}
                            {barcodes !== undefined && barcodes.barcodes.length > 0 && (
                                <div>
                                    {/* tiêu đề modal đã đổi thành "Xác nhận đóng thùng" nên
                                        cần nói rõ khối này là gì; thùng thường giữ nguyên như cũ */}
                                    {!!confirmWarning && <div className="mb-1">Danh sách barcode quét sai:</div>}
                                    {barcodes.barcodes.map((item, index) => {
                                        return (
                                            <div className="mb-1" key={index}><strong>#{item}</strong></div>
                                        )
                                    })}
                                </div>
                            )}
                        </ModalBody>
                        <ModalFooter className="d-flex justify-content-between">
                            <Button color="default" onClick={this._handleCancelModal}>Hủy </Button>
                            <Button color="primary" onClick={this._handleClickClose}>Đóng thùng</Button>
                        </ModalFooter>
                    </Modal>
                )}

                {HEAVY_CARRIERS.includes(shipping_carrier) && modalBoxInfo && (
                    <Modal isOpen={modalBoxInfo} toggle={this._handleCancelModalBoxInfo} className='EditInfoBox' style={{maxWidth: '500px', width: '100%'}}>
                        <ModalHeader toggle={this._handleCancelModalBoxInfo}>Thùng #{box.id}</ModalHeader>
                        <ModalBody>
                            <div className='mb-3'>
                                <Select
                                    style={{width: 300}}
                                    showArrow={true}
                                    onChange={this._handleChangeType}
                                    value={typeSelected}
                                >
                                    <Select.Option value="">Chọn loại thùng</Select.Option>
                                    <Select.Option value="bag">Túi</Select.Option>
                                    <Select.Option value="boxHw">Thùng HW</Select.Option>
                                </Select>
                            </div>
                            
                            <h3 className="font-weight-bold">Cân nặng thực tế</h3>
                            <FormGroup className='d-block'>
                                <div className='d-flex'>
                                    <Input name='weight' type='number' value={weight} onChange={this._handleChangeInput} placeholder="Nhập cân nặng thực của thùng"/>
                                    <label className='unit'>kg</label>
                                </div>

                                {errorValidate['weight'] &&
                                    <div className='text-danger mt-1'>{errorValidate['weight']}</div>
                                }
                            </FormGroup>

                            <h3 className="font-weight-bold">Kích thước thực tế</h3>
                            <FormGroup className='d-block'>
                                <div className='d-flex'>
                                    <Input name='length' type='number' value={length} onChange={this._handleChangeInput} placeholder="Chiều dài"/>
                                    <label className='unit'>cm</label>
                                </div>

                                {errorValidate['length'] &&
                                    <div className='text-danger mt-1'>{errorValidate['length']}</div>
                                }
                            </FormGroup>
    
                            <FormGroup className='d-block'>
                                <div className='d-flex'>
                                    <Input name='width' type='number' value={width} onChange={this._handleChangeInput} placeholder="Chiều rộng"/>
                                    <label className='unit'>cm</label>
                                </div>

                                {errorValidate['width'] &&
                                    <div className='text-danger mt-1'>{errorValidate['width']}</div>
                                }
                            </FormGroup>
    
                            <FormGroup className='d-block'>
                                <div className='d-flex'>
                                    <Input name='height' type='number' value={height} onChange={this._handleChangeInput} placeholder="Chiều cao"/>
                                    <label className='unit'>cm</label>
                                </div>
                                
                                {errorValidate['height'] &&
                                    <div className='text-danger mt-1'>{errorValidate['height']}</div>
                                }
                            </FormGroup>
                        </ModalBody>
                        <ModalFooter>
                            <Button color="secondary" onClick={this._handleCancelModalBoxInfo}>Cancel</Button>{' '}
                            <Button color="primary" onClick={this._handleConfirmClickClose}>Save</Button>
                        </ModalFooter>
                    </Modal>
                )}
            </div>
        )
    }
}

CloseBox.propTypes = {
    box: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
    // Có giá trị -> disable nút "Đóng thùng" và hiện tooltip giải thích lý do
    disabledReason: PropTypes.string,
    // Có giá trị -> vẫn cho đóng nhưng bắt xác nhận lại qua modal
    confirmWarning: PropTypes.string,
}

CloseBox.defaultProps = {
    disabledReason: '',
    confirmWarning: '',
}

export default CloseBox
